import { Component, Input } from "@angular/core";

@Component({
  selector: "app-skeleton-table",
  template: `
    <div class="overflow-x-auto">
      <table class="w-full">
        <thead>
          <tr class="border-b border-n30">
            <th *ngFor="let _ of colArr" class="pb-3 pr-4">
              <div class="skeleton-pulse h-3 rounded" style="width: 60%"></div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let _ of rowArr" class="border-b border-n20">
            <td *ngFor="let w of colWidths" class="py-3.5 pr-4">
              <div class="skeleton-pulse h-3.5 rounded" [style.width]="w"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  `,
})
export class SkeletonTableComponent {
  @Input() rows = 8;
  @Input() cols = 6;
  @Input() columnWidths: string[] = [];

  get rowArr() {
    return Array(this.rows);
  }
  get colArr() {
    return Array(this.cols);
  }
  get colWidths(): string[] {
    if (this.columnWidths.length) return this.columnWidths;
    return Array(this.cols)
      .fill(0)
      .map((_, i) => (i % 3 === 2 ? "40%" : "65%"));
  }
}
